import React, { useState, useEffect } from 'react';
import { database } from '../firebase';
import { ref, onValue, off } from 'firebase/database';
import './DeviceList.css';

const DeviceList = ({ onDeviceSelect, selectedDeviceId }) => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Listen to user SMS messages data from Firebase
    const userSmsRef = ref(database, 'user_sms_messages');
    
    const unsubscribe = onValue(userSmsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const devicesList = Object.keys(data).map(deviceId => {
          const deviceData = data[deviceId];
          const messages = Object.values(deviceData);
          const latestMessage = messages.sort((a, b) => (b.captured_at || 0) - (a.captured_at || 0))[0] || {};
          
          // Check if device is online based on recent activity (within last 5 minutes)
          const lastActivity = latestMessage.captured_at || 0;
          const now = Date.now();
          const fiveMinutesAgo = now - (5 * 60 * 1000);
          const isOnline = lastActivity > fiveMinutesAgo;
          
          return {
            id: deviceId,
            deviceName: latestMessage.user_name || 'Unknown Device',
            mobileNumber: latestMessage.user_mobile || 'Unknown',
            isOnline: isOnline,
            lastSeen: new Date(lastActivity).toISOString(),
            smsCount: messages.length,
            device_id: latestMessage.device_id || deviceId,
            lastActivity: lastActivity
          };
        });
        setDevices(devicesList);
      } else {
        setDevices([]);
      }
      setLoading(false);
    });

    // Cleanup listener on component unmount
    return () => off(userSmsRef, 'value', unsubscribe);
  }, []);

  const getStatusColor = (isOnline) => {
    return isOnline ? '#4CAF50' : '#f44336';
  };

  const getStatusText = (isOnline) => {
    return isOnline ? 'Online' : 'Offline';
  };

  if (loading) {
    return <div className="loading">Loading devices...</div>;
  }

  return (
    <div className="device-list">
      <h3>Connected Devices ({devices.length})</h3>
      {devices.length === 0 ? (
        <p className="no-devices">No devices found</p>
      ) : (
        <div className="devices-grid">
          {devices.map((device) => (
            <div
              key={device.id}
              className={`device-card ${selectedDeviceId === device.id ? 'selected' : ''}`}
              onClick={() => onDeviceSelect(device)}
            >
              <div className="device-header">
                <h4 className="device-name">{device.deviceName || device.name || 'Unknown Device'}</h4>
                <div 
                  className="status-indicator"
                  style={{ backgroundColor: getStatusColor(device.isOnline) }}
                >
                  {getStatusText(device.isOnline)}
                </div>
              </div>
              <div className="device-details">
                <p><strong>Mobile:</strong> {device.mobileNumber || device.phoneNumber || 'Not available'}</p>
                <p><strong>Device ID:</strong> {device.id}</p>
                {device.lastSeen && (
                  <p><strong>Last Seen:</strong> {new Date(device.lastSeen).toLocaleString()}</p>
                )}
                {device.smsCount && (
                  <p><strong>SMS Count:</strong> {device.smsCount}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DeviceList;
